import About from './about'
import App from './app'
import Contact from './contact'
import NotFound from './not-found'
import Press from './press'
import Trailer from './trailer'
import Theaters from './theaters'

export { About, App, Contact, NotFound, Press, Trailer, Theaters }



// WEBPACK FOOTER //
// ./src/components/index.js